import type { ReviewComposerOptions } from './review-flow/types'

interface ComposerState {
  message: string
  options: ReviewComposerOptions | null
  status: 'idle' | 'loading' | 'submitting' | 'error' | 'ownershipError' | 'success'
  reviewId: number | null
}

type ComposerAction =
  | { type: 'message'; message: string }
  | { type: 'options'; options: ReviewComposerOptions }
  | { type: 'status'; status: ComposerState['status'] }
  | { type: 'submitted'; reviewId: number }

export const initialComposerState: ComposerState = { message: '', options: null, status: 'idle', reviewId: null }

export const composerReducer = (state: ComposerState, action: ComposerAction): ComposerState => {
  switch (action.type) {
    case 'message':
      return { ...state, message: action.message }
    case 'options':
      return { ...state, options: action.options }
    case 'status':
      return { ...state, status: action.status }
    case 'submitted':
      return { ...state, status: 'success', reviewId: action.reviewId }
  }
}
